import cookies from 'js-cookie';
import { ON_SERVER } from './context';

const PLC_PREFIX = 'plc-';

export const PLC_TOKEN = `${PLC_PREFIX}token`;

type CookieOptions = {
  expires?: number;
  sameSite?: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None' | undefined;
  secure?: boolean;
};

const defaultOptions: CookieOptions = {
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict',
};

export const cookie = {
  set: (key: string, value: string, options: CookieOptions = {}): void => {
    if (ON_SERVER)
      throw new Error(`Can only set '${key}' cookie on the client`);

    cookies.set(key, value, { ...defaultOptions, ...options });
  },
  get: (key: string): string => {
    if (ON_SERVER)
      throw new Error(`Can only get '${key}' cookie on the client`);
    return cookies.get(key);
  },
  remove: (key: string): void => {
    if (ON_SERVER)
      throw new Error(`Can only remove '${key}' cookie on the client`);
    cookies.remove(key);
  },
};
